(function(root, factory) {
	
	'use strict';
	
	if (typeof define === 'function' && define.amd) {
		// AMD. Register as a named module.
		define('hyperhelper', factory);
	} else {
		// Browser globals
		root.hyperhelper = factory();
	}
}(this, function() {

	'use strict';
	const NAMESPACE_XLINK = 'http://www.w3.org/1999/xlink';
	
	function h(selector) {

		var children = [];
		var properties = {};

		// So chrome can optimize this method
		var args = new Array(arguments.length - 1);
		for (var i = 0, l = args.length; i < l; i++) {
			args[i] = arguments[i+1];
		}

		// Determine semantics of arguments
		for (var s = 0, sl = args.length; s < sl; s++) {
			var $type = typeof args[s];
			if (args[s] === null || args[s] === undefined) {
				continue;

			} else if (args[s] instanceof window.Element) {
				children.push(args[s]);

			} else if ($type === 'string' || $type === 'number') {
				children.push(document.createTextNode(args[s].toString()));

			} else if ($type === 'function') {
				children.push(args[s]());

			} else if (args[s] instanceof Array) {
				children = children.concat(args[s]);

			} else if ($type === 'object') {
				properties = Object.assign(properties, args[s]);

			} else {
				children.push(args[s]);
			}
		}

		// Parse selector tag#id.class1.class2
		const selectorHashPos = selector.indexOf('#');
		const selectorDotPos = selector.indexOf('.', selectorHashPos);

		var tag;
		if (selectorHashPos !== -1) {
			tag = selector.substring(0, selectorHashPos);
		} else if (selectorDotPos !== -1) {
			tag = selector.substring(0, selectorDotPos);
		} else {
			tag = selector;
		}

		var ns;
		if (properties.namespace) {
			ns = properties.namespace;
			delete properties.namespace;
		}

		var node = ns
		    ? document.createElementNS(ns, tag)
		    : document.createElement(tag);

		if (selectorHashPos !== -1) {
			node.id = selector.substring(selectorHashPos + 1, (selectorDotPos !== -1) ? selectorDotPos : selector.length);
		}

		var classList = (selectorDotPos > -1) ? selector.substring(selectorDotPos + 1).split('.') : [];
		if (classList.length) {
			node.classList.add.apply(node.classList, classList);
		}

		// Parse properties
		for (var p in properties) {
			if (Object.prototype.hasOwnProperty.call(properties, p)) {
				var value = properties[p];

				// Events should be added as properties.
				// And not using node.addEventListener(p.substring(2), value)
				if (p.substr(0, 2) == 'on' && typeof value === 'function') {
					node[p] = value;

				} else if (p === 'style') {
					for (var vi in value) {
						if (Object.prototype.hasOwnProperty.call(value, vi)) {
							node.style.setProperty(vi, value[vi]);
						}
					}

				} else if (p === 'attrs') {
					for (var vi in value) {
						if (Object.prototype.hasOwnProperty.call(value, vi)) {
							node.setAttribute(vi, value[vi]);
						}
					}

				} else if (p.substring(0, 6) === 'xlink:') {
					node.setAttributeNS(NAMESPACE_XLINK, p, value);

				} else if (p.substring(0, 5) === 'data-' || ns) {
					node.setAttribute(p, value);

				} else if (value) {
					node[p] = value;
				}
			}
		}

		children.map(function(c) {
			node.appendChild(c);
		});

		return node;
	}
	
	const isSelector = function(p) {
		return typeof p === 'string' && p.length > 0 && (p[0] === '.' || p[0] === '#');
	};
	
	const createTag = function(tagName) {
		return function(first) {
			var rest = new Array(arguments.length - 1);
			for (var i = 0, l = rest.length; i < l; i++) {
				rest[i] = arguments[i+1];
			}
			if (isSelector(first)) {
				return h.apply(undefined, [tagName + first].concat(rest));
			} else if (typeof first === 'undefined') {
				return h(tagName);
			} else {
				return h.apply(undefined, [tagName, first].concat(rest));
			}
		};
	};
	
	const createTagNS = function(tagName, ns) {
		return function(first) {
			var rest = new Array(arguments.length - 1);
			for (var i = 0, l = rest.length; i < l; i++) {
				rest[i] = arguments[i+1];
			}
			if (isSelector(first)) {
				return h.apply(undefined, [tagName + first, {namespace:ns}].concat(rest));
			} else if (typeof first === 'undefined') {
				return h(tagName, {namespace:ns});
			} else {
				return h.apply(undefined, [tagName, first, {namespace:ns}].concat(rest));
			}
		};
	};
	
	const TAG_NAMES = [
	    'a', 'abbr', 'acronym', 'address', 'applet', 'area', 'article', 'aside', 'audio', 'b',
	    'base', 'basefont', 'bdi', 'bdo', 'bgsound', 'big', 'blink', 'blockquote', 'body',
	    'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup',
	    'command', 'content', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog',
	    'dir', 'div', 'dl', 'dt', 'element', 'em', 'embed', 'fieldset', 'figcaption', 'figure',
	    'font', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
	    'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'image', 'img', 'input',
	    'ins', 'isindex', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'listing', 'main',
	    'map', 'mark', 'marquee', 'math', 'menu', 'menuitem', 'meta', 'meter', 'multicol',
	    'nav', 'nextid', 'nobr', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'optgroup',
	    'option', 'output', 'p', 'param', 'picture', 'plaintext', 'pre', 'progress', 'q', 'rb',
	    'rbc', 'rp', 'rt', 'rtc', 'ruby', 's', 'samp', 'script', 'section', 'select', 'shadow',
	    'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary',
	    'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead',
	    'time', 'title', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr', 'xmp'
	];
	
	const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
	const SVG_TAG_NAMES = [
	    'svg', 'a', 'altGlyph', 'altGlyphDef', 'altGlyphItem', 'animate', 'animateColor',
	    'animateMotion', 'animateTransform', 'circle', 'clipPath', 'colorProfile',
	    'cursor', 'defs', 'desc', 'ellipse', 'feBlend', 'feColorMatrix',
	    'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting',
	    'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB',
	    'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode',
	    'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting',
	    'feSpotlight', 'feTile', 'feTurbulence', 'filter', 'font', 'fontFace',
	    'fontFaceFormat', 'fontFaceName', 'fontFaceSrc', 'fontFaceUri',
	    'foreignObject', 'g', 'glyph', 'glyphRef', 'hkern', 'image', 'line',
	    'linearGradient', 'marker', 'mask', 'metadata', 'missingGlyph', 'mpath',
	    'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'script',
	    'set', 'stop', 'style', 'switch', 'symbol', 'text', 'textPath', 'title',
	    'tref', 'tspan', 'use', 'view', 'vkern'
	];
	
	const exported = { TAG_NAMES: TAG_NAMES, SVG_TAG_NAMES: SVG_TAG_NAMES, isSelector: isSelector, createTag: createTag, svg: {} };
	
	TAG_NAMES.forEach(function(n) {
		exported[n] = createTag(n);
	});
	
	SVG_TAG_NAMES.forEach(function(n) {
		exported.svg[n] = createTagNS(n, SVG_NAMESPACE);
	});
	
	return exported;
}));

// -----IDD-MINIFY-SETTINGS
// ecmaVersion:11
// -----IDD-MINIFY-SETTINGS-DONE
